import { render } from "./RefundAuditListView.vue?vue&type=template&id=1195dc84&scoped=true"
import script from "./RefundAuditListView.vue?vue&type=script&lang=js"
export * from "./RefundAuditListView.vue?vue&type=script&lang=js"

import "./RefundAuditListView.vue?vue&type=style&index=0&id=1195dc84&lang=scss&scoped=true"

import exportComponent from "/root/workspace/bjyx-h5_Pbc0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1195dc84"]])

export default __exports__